/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Lademittel } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * LademittelService - axios parameter creator
 * @export
 */
export const LademittelServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Lademitteln
         * @summary Lademittel
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLademittel: async (mandant?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lademittel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mandant !== undefined) {
                localVarQueryParameter['mandant'] = mandant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert ein Lademittel
         * @summary Lademittel
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLademittelById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLademittelById', 'id', id)
            const localVarPath = `/api/lademittel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert alle Lademittel für einen Mandanten die nur GGVS Lademittel sind oder kein GGVS
         * @summary Lademittel
         * @param {number} [mandant] mandant
         * @param {boolean} [isGGVS] isGGVS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLademittelOnlyGGVSOrWithout: async (mandant?: number, isGGVS?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/lademittel/ggvs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mandant !== undefined) {
                localVarQueryParameter['mandant'] = mandant;
            }

            if (isGGVS !== undefined) {
                localVarQueryParameter['isGGVS'] = isGGVS;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LademittelService - functional programming interface
 * @export
 */
export const LademittelServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LademittelServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Lademitteln
         * @summary Lademittel
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLademittel(mandant?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Lademittel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLademittel(mandant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert ein Lademittel
         * @summary Lademittel
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLademittelById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Lademittel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLademittelById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert alle Lademittel für einen Mandanten die nur GGVS Lademittel sind oder kein GGVS
         * @summary Lademittel
         * @param {number} [mandant] mandant
         * @param {boolean} [isGGVS] isGGVS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLademittelOnlyGGVSOrWithout(mandant?: number, isGGVS?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Lademittel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLademittelOnlyGGVSOrWithout(mandant, isGGVS, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LademittelService - factory interface
 * @export
 */
export const LademittelServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LademittelServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Lademitteln
         * @summary Lademittel
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLademittel(mandant?: number, options?: any): AxiosPromise<Array<Lademittel>> {
            return localVarFp.getLademittel(mandant, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert ein Lademittel
         * @summary Lademittel
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLademittelById(id: number, options?: any): AxiosPromise<Lademittel> {
            return localVarFp.getLademittelById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert alle Lademittel für einen Mandanten die nur GGVS Lademittel sind oder kein GGVS
         * @summary Lademittel
         * @param {number} [mandant] mandant
         * @param {boolean} [isGGVS] isGGVS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLademittelOnlyGGVSOrWithout(mandant?: number, isGGVS?: boolean, options?: any): AxiosPromise<Array<Lademittel>> {
            return localVarFp.getLademittelOnlyGGVSOrWithout(mandant, isGGVS, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LademittelService - interface
 * @export
 * @interface LademittelService
 */
export interface LademittelServiceInterface {
    /**
     * Liefert eine Liste von Lademitteln
     * @summary Lademittel
     * @param {number} [mandant] mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LademittelServiceInterface
     */
    getLademittel(mandant?: number, options?: any): AxiosPromise<Array<Lademittel>>;

    /**
     * Liefert ein Lademittel
     * @summary Lademittel
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LademittelServiceInterface
     */
    getLademittelById(id: number, options?: any): AxiosPromise<Lademittel>;

    /**
     * Liefert alle Lademittel für einen Mandanten die nur GGVS Lademittel sind oder kein GGVS
     * @summary Lademittel
     * @param {number} [mandant] mandant
     * @param {boolean} [isGGVS] isGGVS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LademittelServiceInterface
     */
    getLademittelOnlyGGVSOrWithout(mandant?: number, isGGVS?: boolean, options?: any): AxiosPromise<Array<Lademittel>>;

}

/**
 * LademittelService - object-oriented interface
 * @export
 * @class LademittelService
 * @extends {BaseAPI}
 */
export class LademittelService extends BaseAPI implements LademittelServiceInterface {
    /**
     * Liefert eine Liste von Lademitteln
     * @summary Lademittel
     * @param {number} [mandant] mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LademittelService
     */
    public getLademittel(mandant?: number, options?: any) {
        return LademittelServiceFp(this.configuration).getLademittel(mandant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert ein Lademittel
     * @summary Lademittel
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LademittelService
     */
    public getLademittelById(id: number, options?: any) {
        return LademittelServiceFp(this.configuration).getLademittelById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert alle Lademittel für einen Mandanten die nur GGVS Lademittel sind oder kein GGVS
     * @summary Lademittel
     * @param {number} [mandant] mandant
     * @param {boolean} [isGGVS] isGGVS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LademittelService
     */
    public getLademittelOnlyGGVSOrWithout(mandant?: number, isGGVS?: boolean, options?: any) {
        return LademittelServiceFp(this.configuration).getLademittelOnlyGGVSOrWithout(mandant, isGGVS, options).then((request) => request(this.axios, this.basePath));
    }
}
